import { useRoute } from 'vue-router'
import useGet from '../../../core/composables/api/useGet'
import { onMounted } from 'vue'
import type { JSONContent } from '@tiptap/core'
import type { FeedbackTopic } from '../../../core/models/feedback-topic'

export const useFinalSuperpowerSlide = (feedbackTopicId: string) => {
  const route = useRoute()

  const { data, load, status } = useGet<DialogFinalSuperpowerSlide>(
    `dialog/${route.params.id}/superpower-slide/${feedbackTopicId}`,
  )

  onMounted(() => load())

  return { data, status }
}

export interface DialogFinalSuperpowerSlide {
  readonly feedbackTopic: FeedbackTopic
  readonly superpower?: {
    id: string
    title: string
    color: string
    image?: string
    date: string
  }
  readonly spontaneousFeedbacks: ReadonlyArray<{
    id: string
    text: JSONContent
    date: string
  }>
}
